import { makeStyles } from "@material-ui/core";
import { useEvent, useIO } from "@type-r/react";
import { Column, Columns, Flex, FormCheckbox, FormInput, FormSelect, Loading, Option, ReadOnly, Toolbar } from "lqx-react/lib";
import React, { useEffect } from "react";
import { RelationshipModel } from "api/relationship";
import { MultiEmailInput } from "../../../../../common/emails";
import { CpSaveButton } from "../common/api";
import { Events } from "@type-r/models";

export const CpStatementOfAccount = ({ $selected, canEdit }: {
    $selected: RelationshipModel,
    canEdit: Boolean
}) => {
    const classes = useStyles();
    const statement = $selected.cpStatement;
    const sendingMethods = ['Mail', 'Not Needed', 'Web Portal', 'Parent Customer', 'Email'];
    const frequency = ['Weekly', 'Bi-Weekly', 'Monthly'];
    const disableWebPortalControls = statement.$.sendingMethod.value !== 'Web Portal';
    const readOnly = React.useContext( ReadOnly ) || !canEdit;
    
    const loadData = async () => {
        await $selected.cpStatement.fetch().catch(onError);
    }
    const isReady = useIO(loadData, []);

    useEvent(Events, "cpImport:done", loadData);

    const save = async () => {
        await $selected.cpStatement.save();
    }

    const onError = (e) => {
        console.error(e);
    }

    const clearWebPortal = () => {
        statement.webPortalUrl = '';
        statement.webPortalUser = '';
        statement.webPortalPwd = '';
    }

    useEffect( () => {
        if(disableWebPortalControls) {
            clearWebPortal();
        }
    }, [ statement.sendingMethod ])

    return (
        isReady ? <>
            <ReadOnly.Provider value={ readOnly }>
                <Columns className={ classes.container }>
                    <Column>
                        <FormInput label="Customer ID" $value={statement.$.customerId} />
                        <FormSelect label="Sending Method" $value={statement.$.sendingMethod} >
                            {sendingMethods.map(sm => <Option key={sm} value={sm}>{sm}</Option>)}
                        </FormSelect>
                        <FormCheckbox label="UAC Included in SOA" $checked={statement.$.uacIncludedInSoa} readOnly={!canEdit} />
                        <MultiEmailInput $emails={statement.$.receiptMailAddress as any} label={'Receipt Mail Address'} />
                        <FormInput label="Web Portal URL" $value={statement.$.webPortalUrl} disabled={disableWebPortalControls} />
                        <FormInput label="Web Portal User" $value={statement.$.webPortalUser} disabled={disableWebPortalControls} />
                        <FormInput type="password" label="Web Portal Pwd" $value={statement.$.webPortalPwd} disabled={disableWebPortalControls} />
                    </Column>
                    <Column>
                        <FormSelect label="Frequency" $value={statement.$.frequency} >
                            {frequency.map(f => <Option key={f} value={f}>{f}</Option>)}
                        </FormSelect>
                        <FormCheckbox label="Auto Send SOA Enabled" $checked={statement.$.autoSendSoa} readOnly={!canEdit} />
                        <FormCheckbox label="SOA Due in 2 Weeks" $checked={statement.$.soaDueIn2Weeks} readOnly={!canEdit} />
                        <Flex grow />
                    </Column>
                </Columns>
            </ReadOnly.Provider>
            <Toolbar>
                <Flex grow />
                {canEdit && <CpSaveButton onClick={save} label={'Save statement of account data?'}/>}
            </Toolbar>
        </> : < Loading />
    );
}

const useStyles = makeStyles({
    container : {
        alignItems: "baseline"
    }
});